// Third Party
import * as React from 'react';

// Utils
import { routes } from '@routes';
import { GiftCard } from './types';

// UI
import { Typography } from '@components/typography';
import { Link } from '@components/link';
import { GiftCardSubnav } from '@pages-components/gift-cards/gift-card-subnav';
import { GiftCardLookupForm } from './gift-card-lookup-form';
import { GiftCardInfo } from './gift-card-info';

type Props = {};

export const GiftCardLookup: React.FC<Props> = () => {
  const [giftCard, setGiftCard] = React.useState<GiftCard | undefined>(
    undefined
  );

  return (
    <div>
      <GiftCardSubnav />
      <div className="body-container mt-8 mb-24 space-y-8 text-primary-main">
        {giftCard ? (
          <GiftCardInfo giftCard={giftCard} setGiftCard={setGiftCard} />
        ) : (
          <GiftCardLookupForm setGiftCard={setGiftCard} />
        )}

        <div className="text-center container mx-auto">
          <Typography component="h2" variant="title3" variantM="title2">
            Questions?
          </Typography>
          <Typography
            component="p"
            variant="body1"
            className="mt-2 px-0 sm:px-16 md:px-32"
          >
            If you have any questions about your gift card, the automated
            balance process, or reprinting your certificate, please do not
            hesitate to{' '}
            <Link
              target="_blank"
              rel="noreferrer"
              to={routes.help}
              className="a"
            >
              contact us
            </Link>{' '}
            - We&apos;d be happy to help!
          </Typography>
        </div>
      </div>
    </div>
  );
};
